<app-dialog
  #dialog
  [key]="'partner-contract-preview'"
  [action]="'partner-contract-preview'"
  [headerTheme]="'simple'"
  [title]="'Pré-visualização do contrato'"
  [appendTo]="'body'"
  [maxWidth]="'960px'"
  [showMaximizeButton]="true">
  <div class="contract-preview">
    @if (unfilledDescription) {
      <div class="contract-preview__warning" role="status">
        <i class="pi pi-exclamation-triangle"></i>
        <span>
          <strong>Faltam dados:</strong> {{ unfilledDescription }}. Eles aparecem destacados em
          amarelo no texto e no PDF.
        </span>
      </div>
    }

    @if (revisionLabel) {
      <div class="contract-preview__revision" role="status">
        <i class="pi pi-history"></i>
        <span>
          <strong>{{ revisionLabel }}</strong
          >. Texto gravado naquela revisão, só para leitura.
          @if (canUseText) {
            Use <strong>Usar este texto</strong> para levá-lo ao editor; nada é salvo até você
            clicar em Salvar.
          }
        </span>
      </div>
    } @else {
      <p class="contract-preview__hint">
        Este é o texto que está no editor agora, mesmo sem salvar. O PDF inclui também a capa com a
        identidade da Legatus e o rodapé com o número da página.
      </p>
    }

    <div class="contract-preview__canvas">
      <article class="contract-preview__sheet">
        <h2 class="contract-preview__title">{{ title }}</h2>
        <div class="contract-preview__body" [innerHTML]="html"></div>
      </article>
    </div>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      @if (canUseText) {
        <app-button
          label="Usar este texto"
          icon="pi pi-replay"
          [type]="'button'"
          (sendButtonClick)="useThisText()" />
      }
      <app-button
        label="Fechar"
        theme="white"
        [type]="'button'"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>
